import Header from './header/Header';
import MiddleSchoolHeader from './MiddleSchoolHeader';
import { useSelectedClassroom } from '../Classrooms';
import { LoginState } from '../UserManagement';
import { History, Location } from 'history';

interface Props {
  loginState: LoginState;
  isAuthenticated: boolean;
  onShowGetStartedDialog: () => void;
  history: History;
  location: Location;
  params: {
    classroomName?: string;
  };
  isHidePeekaville?: boolean;
}

const HeaderRedirect = (props: Props) => {
  const newProps = { ...props };
  const selection = useSelectedClassroom();

  if (selection.status === 'loading') {
    return null;
  }

  // 'empty' (loaded, but the teacher has no classrooms) still gets the default
  // header so the user keeps navigation and sign-out instead of a blank page.
  if (selection.status === 'ready' && parseInt(selection.classroom.grade) > 5) {
    return <MiddleSchoolHeader {...newProps} />;
  }

  return <Header {...newProps} />;
};

export default HeaderRedirect;
